import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsOptional } from "class-validator";

  export class RoleActivityDTO {
    @ApiProperty()
    @IsOptional()
    Id?: number;
    @ApiProperty()
    @IsNotEmpty({message:"role should not be empty"})  
    roleId:number;
    @ApiProperty()
    @IsNotEmpty({message:"activity should not be empty"})  
    activityId:any;
    @ApiProperty()
    status: boolean;
    createdAt : Date;
    @ApiProperty()
    @IsOptional()
    createdUser : number;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    updatedUser : number;
    @ApiProperty()
    versionFlag : number;
  }
  
export class getroleActivitysDTO {
  @ApiProperty()
  @IsNotEmpty({message:"user id should not be empty"})    
  userId:number; 
  @ApiProperty()
  fcmToken:string;  
}

  